import { ProjectListRes } from '../../api/MaterialApi'
import { PlatformField } from '@/modules/goodsdetailmodules/reducer'

const initialRadioDict = {
  类目信息: {
    key: 'toAssure',
    keyName: '类目信息',
    numMap: '1',
  },
  单位信息: {
    key: 'ausuring',
    keyName: '单位信息',
    numMap: '2',
  },
  品牌信息: {
    key: 'toCheck',
    keyName: '品牌信息',
    numMap: '3',
  },
}

interface State {
  relationProjectList: ProjectListRes[]
  formData: any
  isOpenModal: boolean
  checkedRadioKey: string
  searchParam: any
  currentRadioDict: any
  modalList: any
  filteredPlatformList: PlatformField[]
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setRelationProjectListAction'
  | 'setIsOpenModalAction'
  | 'setCheckedRadioKey'
  | 'setSearchParam'
  | 'setModalListAction'
  | 'setFilteredPlatformList'
interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  relationProjectList: [],
  isOpenModal: false,
  checkedRadioKey: '类目信息',
  searchParam: {},
  currentRadioDict: initialRadioDict,
  modalList: [],
  filteredPlatformList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setRelationProjectListAction':
      newstate.relationProjectList = action.payload
      return newstate
    case 'setIsOpenModalAction':
      newstate.isOpenModal = action.payload
      return newstate
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setModalListAction':
      newstate.modalList = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setFilteredPlatformList':
      newstate.filteredPlatformList = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setRelationProjectListAction = (
  val: ProjectListRes[],
): Action => ({
  type: 'setRelationProjectListAction',
  payload: val,
})
/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

export const setIsOpenModalAction = (val: boolean): Action => ({
  type: 'setIsOpenModalAction',
  payload: val,
})

export const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

export const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

export const setModalListAction = (val: any): Action => ({
  type: 'setModalListAction',
  payload: val,
})

export const setFilteredPlatformList = (val: PlatformField[]): Action => ({
  type: 'setFilteredPlatformList',
  payload: val,
})
import { ProjectListRes } from '../../api/MaterialApi'
import { PlatformField } from '@/modules/goodsdetailmodules/reducer'

const initialRadioDict = {
  类目信息: {
    key: 'toAssure',
    keyName: '类目信息',
    numMap: '1',
  },
  单位信息: {
    key: 'ausuring',
    keyName: '单位信息',
    numMap: '2',
  },
  品牌信息: {
    key: 'toCheck',
    keyName: '品牌信息',
    numMap: '3',
  },
}

interface State {
  relationProjectList: ProjectListRes[]
  formData: any
  isOpenModal: boolean
  checkedRadioKey: string
  searchParam: any
  currentRadioDict: any
  modalList: any
  filteredPlatformList: PlatformField[]
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setRelationProjectListAction'
  | 'setIsOpenModalAction'
  | 'setCheckedRadioKey'
  | 'setSearchParam'
  | 'setModalListAction'
  | 'setFilteredPlatformList'
interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  relationProjectList: [],
  isOpenModal: false,
  checkedRadioKey: '类目信息',
  searchParam: {},
  currentRadioDict: initialRadioDict,
  modalList: [],
  filteredPlatformList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setRelationProjectListAction':
      newstate.relationProjectList = action.payload
      return newstate
    case 'setIsOpenModalAction':
      newstate.isOpenModal = action.payload
      return newstate
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setModalListAction':
      newstate.modalList = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setFilteredPlatformList':
      newstate.filteredPlatformList = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setRelationProjectListAction = (
  val: ProjectListRes[],
): Action => ({
  type: 'setRelationProjectListAction',
  payload: val,
})
/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

export const setIsOpenModalAction = (val: boolean): Action => ({
  type: 'setIsOpenModalAction',
  payload: val,
})

export const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

export const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

export const setModalListAction = (val: any): Action => ({
  type: 'setModalListAction',
  payload: val,
})

export const setFilteredPlatformList = (val: PlatformField[]): Action => ({
  type: 'setFilteredPlatformList',
  payload: val,
})
